<template>
  <div class="mh-20 mv-12 flex">
    <div class="flex space-x-3">
      <BlFlexContainerMv class="image-wrapper" justify-content="center" align-items="center">
        <img :src="illustrationUrl" class="rounded w-full h-full object-cover qa-img-course" width="50" />
      </BlFlexContainerMv>
      <div>
        <BlTextAv class="qa-txt-caption" variation="caption-12" color="subdued">
          Kamu mau ikut kelas{{ courseTypeWording ? ` ${courseTypeWording}` : '' }}:
        </BlTextAv>
        <BlTextAv :ellipsis="2" class="qa-txt-course-name">{{ name }}</BlTextAv>
      </div>
    </div>
  </div>
</template>

<script>
import {COURSE_TYPE} from '../../config/app';

export default {
  name: 'PrakerjaCheckoutSelectedVoucher',
  props: {
    name: {
      type: String,
      required: true,
    },
    courseType: {
      type: String,
      default: '',
    },
    illustrationUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    courseTypeWording() {
      if (!this.courseType) return '';
      return COURSE_TYPE[this.courseType].toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.image-wrapper {
  margin-bottom: 0;
  min-width: 50px;
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #f1f2f5;
  padding: 5px;
}
</style>
